import { defineStore } from 'pinia'
import { ref } from 'vue'

const LS_KEY = 'poker_sound_prefs'

export type BgmTrack = 'jazz' | 'lofi' | 'edm' | 'none'

interface SoundPrefs {
  sfxVolume:      number
  bgmVolume:      number
  sfxMuted:       boolean
  bgmMuted:       boolean
  bgmTrack:       BgmTrack
  yourTurnEnabled: boolean
}

function load(): SoundPrefs {
  try {
    const raw = localStorage.getItem(LS_KEY)
    if (raw) return { ...defaults(), ...JSON.parse(raw) }
  } catch {}
  return defaults()
}

function defaults(): SoundPrefs {
  return { sfxVolume: 0.8, bgmVolume: 0.4, sfxMuted: false, bgmMuted: false, bgmTrack: 'jazz', yourTurnEnabled: true }
}

function save(p: SoundPrefs): void {
  localStorage.setItem(LS_KEY, JSON.stringify(p))
}

export const useSoundStore = defineStore('sound', () => {
  const init = load()
  const sfxVolume      = ref(init.sfxVolume)
  const bgmVolume      = ref(init.bgmVolume)
  const sfxMuted       = ref(init.sfxMuted)
  const bgmMuted       = ref(init.bgmMuted)
  const bgmTrack       = ref<BgmTrack>(init.bgmTrack)
  const yourTurnEnabled = ref(init.yourTurnEnabled)

  function persist() {
    save({ sfxVolume: sfxVolume.value, bgmVolume: bgmVolume.value,
           sfxMuted: sfxMuted.value, bgmMuted: bgmMuted.value, bgmTrack: bgmTrack.value,
           yourTurnEnabled: yourTurnEnabled.value })
  }

  function setSfxVolume(v: number) { sfxVolume.value = Math.max(0, Math.min(1, v)); persist() }
  function setBgmVolume(v: number) { bgmVolume.value = Math.max(0, Math.min(1, v)); persist() }
  function toggleSfxMuted() { sfxMuted.value = !sfxMuted.value; persist() }
  function toggleBgmMuted() { bgmMuted.value = !bgmMuted.value; persist() }
  function setBgmTrack(t: BgmTrack) { bgmTrack.value = t; persist() }
  function toggleYourTurn() { yourTurnEnabled.value = !yourTurnEnabled.value; persist() }

  return { sfxVolume, bgmVolume, sfxMuted, bgmMuted, bgmTrack, yourTurnEnabled,
           setSfxVolume, setBgmVolume, toggleSfxMuted, toggleBgmMuted, setBgmTrack, toggleYourTurn }
})
